module.exports = __webpack_public_path__ + "img/contacto-icono-tel.853bc246.svg";